// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WhatsGoingOnSection_wrapper__1KGjE","instagram-btn-row":"WhatsGoingOnSection_instagram-btn-row__1rLwh"};